export function toggleMobileMenu() {
    $(document).ready(function() {
        $('.js--menu_mobile__btn').on('click', function() {
            $('.js--menu_mobile').css('left', '-250px');
            $('.js--menu_mobile').removeClass('menu_mobile--open');
        });
        $('.js--menu_mobile__opener').on('click', function() {
            $('.js--menu_mobile').css('left', '0');
            $('.js--menu_mobile').addClass('menu_mobile--open');
        })
    });
}


// WEBPACK FOOTER //
// ./private/blocks/menu_mobile/menu_mobile.js